<!-- Toast with dynamic styling based on type input -->
<p-toast position="top-right" [life]="3000" [key]="key" [ngClass]="'toast-style-' + type">
	<ng-template let-message pTemplate="message">
		<span class="p-toast-message-icon">
			<!-- Custom SVG based on severity -->
			@if (message.severity === 'success') {
				<!-- Success Icon - Check mark -->
				<svg aria-hidden="true" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle class="icon-circle" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.55" fill="none"/>
					<path class="icon-symbol" d="M9 12L11 14L15 10" stroke="currentColor" stroke-width="1.55" stroke-linecap="round" stroke-linejoin="round"/>
				</svg>
			}
			@if (message.severity === 'info') {
				<!-- Info Icon - Inverted exclamation (rotated 180°) -->
				<svg aria-hidden="true" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle class="icon-circle" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.55" fill="none"/>
					<path class="icon-symbol" d="M12 16V12" stroke="currentColor" stroke-width="1.55" stroke-linecap="round" stroke-linejoin="round"/>
					<path class="icon-symbol" d="M12 8H12.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
				</svg>
			}
			@if (message.severity === 'warn') {
				<!-- Warning Icon - Alert/Exclamation -->
				<svg aria-hidden="true" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle class="icon-circle" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.55" fill="none"/>
					<path class="icon-symbol" d="M12 8V12" stroke="currentColor" stroke-width="1.55" stroke-linecap="round" stroke-linejoin="round"/>
					<path class="icon-symbol" d="M12 16H12.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
				</svg>
			}
			@if (message.severity === 'error') {
				<!-- Error Icon - X mark -->
				<svg aria-hidden="true" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle class="icon-circle" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.55" fill="none"/>
					<path class="icon-symbol" d="M15 9L9 15" stroke="currentColor" stroke-width="1.55" stroke-linecap="round" stroke-linejoin="round"/>
					<path class="icon-symbol" d="M9 9L15 15" stroke="currentColor" stroke-width="1.55" stroke-linecap="round" stroke-linejoin="round"/>
				</svg>
			}
		</span>
		<div class="p-toast-message-text">
			@if (message.summary) {
				<span class="p-toast-summary">{{ message.summary }}</span>
			}
			@if (message.detail) {
				<div class="p-toast-detail">{{ message.detail }}</div>
			}
		</div>
	</ng-template>
</p-toast>
